"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FailedHandledRequestMessage = exports.SuccessfulHandledRequestMessage = void 0;
class SuccessfulHandledRequestMessage {
    constructor(actionName, metadata, result) {
        this.actionName = actionName;
        this.metadata = { ...metadata };
        this.success = true;
        this.result = result;
    }
}
exports.SuccessfulHandledRequestMessage = SuccessfulHandledRequestMessage;
class FailedHandledRequestMessage {
    constructor(actionName, metadata, error) {
        this.actionName = actionName;
        this.metadata = { ...metadata };
        this.success = false;
        this.error = error;
    }
}
exports.FailedHandledRequestMessage = FailedHandledRequestMessage;
